<template>
  <div class="pt-usdc-withdraw-container">
    <UsdcWithdraw ref="TransferFormWrapper" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import UsdcWithdraw from '@/views/withdraw/UsdcWithdraw.vue';
export default {
  name: `PtUsdcWithdraw`,
  components: { UsdcWithdraw }
};
</script>

<style lang="scss">
@import '@/assets/css/pages/propTrading/components/payout/payout-withdraw.scss';
</style>
